import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyUrl: string;
    projectSettings: string;
    openInNewTab: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label to copy project URL */
            copyUrl: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectContextMenuContent.copyUrl?c=dubbsl04cxng", defaultMessage: "Copy URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to open project settings */
            projectSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectContextMenuContent.projectSettings?c=2okd1owibl5lb", defaultMessage: "Project Settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to open project in a new tab */
            openInNewTab: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectContextMenuContent.openInNewTab?c=3gbxo9enryfdt", defaultMessage: "Open in New Tab" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
